export default [
    {
        path: '/occurrenceValidation',
        name: 'occurrenceValidation',
        component: () => import ('./pages/Index')
    },
]